import * as api from "../../helpers/api_helper";
import { GET_ALL_NOTIFICATIONS, MARK_AS_READ } from "../../helpers/url_helper";

export const getAllService = () => api.get(GET_ALL_NOTIFICATIONS);
export const markAsReadService = (id) => api.post(`${MARK_AS_READ}markAsRead/${id}`);